import { YStack } from "tamagui";

import { Heading, Paragraph } from "@/components";

/**
 * Shown in place of the visit-start UI when the patient's account merge is still
 * in progress: a new visit can't be started until the merge finishes. Rendered
 * by the visit-start hosts (ClinicRedirect, CuraiConsentRedirect) when
 * `useCuraiVisitRedirect` reports `isBlockedByMerge`.
 */
export default function VisitBlockedByMergeNotice() {
  return (
    <YStack flex={1} gap="$150" padding="$200" testID="visit-blocked-by-merge">
      {/* TODO(copy): finalize wording with product. */}
      <Heading size="$lg">Your account merge is in progress</Heading>
      <Paragraph size="$sm" color="$textSecondary">
        Your account merge is still in progress. You'll be able to start a visit
        once it finishes.
      </Paragraph>
    </YStack>
  );
}
